import React, { useRef, useState, useEffect, useCallback } from "react";
import { Typography, Tooltip, Box, IconButton } from "@mui/material";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

interface CellTextProps {
  children: string;
}

const CellTextWithCopy = ({ children }: CellTextProps) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const checkTruncation = useCallback(() => {
    if (textRef.current) {
      // Compare scrollWidth with the visible clientWidth
      setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
    }
  }, []);

  // useEffect(() => {
  //   checkTruncation();

  //   // Observe element resizing
  //   const resizeObserver = new ResizeObserver(() => {
  //     checkTruncation();
  //   });
  //   if (textRef.current) resizeObserver.observe(textRef.current);

  //   return () => {
  //     if (textRef.current) {
  //       resizeObserver.unobserve(textRef.current);
  //     }
  //   };
  // }, [children, checkTruncation]);

  const handleCopy = () => {
    navigator.clipboard
      .writeText(children)
      .then(() => console.log("Copied to clipboard!"))
      .catch((err) => console.error("Failed to copy text:", err));
  };

  return (
    <Box
      // The parent container is a flex row
      sx={{
        display: "flex",
        alignItems: "center",
        width: "100%",
        minWidth: 0, // crucial for truncation
        overflow: "hidden",
      }}
    >
      {/* The text area grows/shrinks but can truncate */}
      <Box
        sx={{
          flex: 1,
          minWidth: 0,
          overflow: "hidden",
        }}
      >
        <Tooltip title={children} disableHoverListener={!isTruncated}>
          {/* `noWrap` + truncation styles */}
          <Typography
            ref={textRef}
            variant="body2"
            noWrap
            sx={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
            {children}
          </Typography>
        </Tooltip>
      </Box>

      {/* Copy icon anchored on the right */}
      {children && <Box sx={{ flexShrink: 0, ml: 1 }}>
        <Tooltip title='Copy Items' >
          <IconButton onClick={handleCopy} size="small" aria-label="copy text">
            <ContentCopyIcon fontSize="small" />
          </IconButton>

        </Tooltip>
      </Box>}
    </Box>
  );
};

export default CellTextWithCopy;
